"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  ownerState: {
    isBasketSharingEnabled
  },
  theme
}) => ({
  ..._constants.centeredFlexStyles,
  position: 'absolute',
  top: theme.spacing(13),
  bottom: theme.spacing(9),
  width: '100%',
  height: `calc(100% - ${theme.spacing(28 + (isBasketSharingEnabled ? 11 : 0))})`,
  // 100% - (header + footer height)
  background: (0, _mui.alpha)(theme.palette.common.white, 0.5),
  zIndex: 999
}));